import { useEffect } from "react";
import { Capacitor } from "@capacitor/core";

/**
 * Native-only side effects: status bar style, splash screen dismissal,
 * Android hardware back-button handling.
 *
 * Tree-shake friendly: only triggers Capacitor APIs when running inside
 * a real native shell (`Capacitor.isNativePlatform()`). On the web build
 * it short-circuits and renders nothing.
 *
 * Mount once near the root of <App />.
 */
export default function CapacitorBoot() {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;
    let unsubscribe;

    (async () => {
      try {
        const { StatusBar, Style } = await import("@capacitor/status-bar");
        await StatusBar.setStyle({ style: Style.Dark });
        await StatusBar.setBackgroundColor({ color: "#ff4500" }).catch(() => {}); // iOS no-op
      } catch {}

      try {
        const { SplashScreen } = await import("@capacitor/splash-screen");
        await SplashScreen.hide({ fadeOutDuration: 250 });
      } catch {}

      try {
        const { App } = await import("@capacitor/app");
        const listener = await App.addListener("backButton", ({ canGoBack }) => {
          if (canGoBack) {
            window.history.back();
          } else {
            App.exitApp();
          }
        });
        unsubscribe = () => listener?.remove?.();
      } catch {}
    })();

    return () => unsubscribe?.();
  }, []);

  return null;
}
